import { render } from "./MergePhaseDialog.vue?vue&type=template&id=2f0532cf&scoped=true"
import script from "./MergePhaseDialog.vue?vue&type=script&lang=js"
export * from "./MergePhaseDialog.vue?vue&type=script&lang=js"

import "./MergePhaseDialog.vue?vue&type=style&index=0&id=2f0532cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0532cf"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QForm,QBanner,QIcon,QSelect,QItem,QItemSection,QInput,QBtn});qInstall(script, 'directives', {ClosePopup});
